import React, { useState } from 'react'
import { useObject } from 'react-firebase-hooks/database'
import { useDispatch, useSelector } from 'react-redux'
import { completeTask } from 'src/ducks/mission'
import { getLiveTokenDb } from 'src/firebaseConfig'
import { SIZES } from 'src/styles/theme'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'
import gold from '../../images/gamification/gold-to-collect.png'
import silver from '../../images/gamification/silver-to-collect.png'

const Wrapper = styled.div`
  position: absolute;
  opacity: 0;
  animation: appear 1s 1s forwards;
  z-index: 9999;
  cursor: pointer;
  ${(props) => props.css}
  #coin {
    animation: bounce 3s infinite;
  }
  ${SIZES.mobile} {
    opacity: 1;
    img {
      margin-top: -20px;
    }
  }
`
const randomPosition = [
  `top: 18%; left: 20%;`,
  `top: 25%; left: 15%;`,
  `top: 43%; left: 5%;`,
  `top: 75%; left: 18%;`,
  `top: 17%; left: 85%;`,
  `top: 25%; left: 80%;`,
  `top: 43%; left: 30%;`,
  `top: 63%; left: 40%;`,
]

export const LiveMissionToken = ({ mission, isLive=true }) => {
  const dispatch = useDispatch()
  const [positionIndex, setPositionIndex] = useState(Math.floor(Math.random() * randomPosition.length))
  const { isMissionLoading } = useSelector((state) => state.mission)
  const { currentUser } = useSelector((state) => state.auth)
  const [snapshot, loading, error] = useObject(getLiveTokenDb(mission.id))
  const [clicked, setClicked] = useState(false)

  const collectCoin = (mission) => {
    if (!isMissionLoading) {
      Amplitude.collectCoin(mission.id)
      dispatch(completeTask({
        mission_id: mission.id,
        mission_name: mission.task_name,
      }))
      setClicked(true)
    }
  }
  if (currentUser?.role === 'exhibitor') {
    return <></>
  }
  if (isLive) {
    if (!loading && !error && snapshot && snapshot.val() && snapshot.val().missionId) {
      return (
        <Wrapper css={randomPosition[positionIndex]}>
          {
            (!mission.completed && !clicked) &&
            <img id="coin" onClick={()=>collectCoin(mission)} src={mission.points == 10 ? gold : silver} width="70px" alt="coin" />
          }
        </Wrapper>
      )
    } else {
      return null
    }
  } else {
    return (
      <Wrapper css={randomPosition[positionIndex]}>
        {
          (!mission.completed && !clicked) &&
          <img id="coin" onClick={()=>collectCoin(mission)} src={mission.points == 10 ? gold : silver} width="70px" alt="coin" />
        }
      </Wrapper>
    )
  }
}
